{
    "nav__home": "Vetriebschancen",
    "nav__draft_quotes": "Entwurf Angebote",
    "nav__quotes": "Angebote",
    "nav__orders": "Aufträge",

    "sidebar__title_customers": "Kunden",
    "sidebar__subtitle_oppertunity_count": "Kunden mit Vertriebschancen",
    "sidebar__search_placeholder": "Suche nach Kunden, Lieferaufträgen usw.",
    "sidebar__slice_count": "offen",
    "sidebar__slice_business_value": "geschätzt",

    "header__business_value": "geschätztes totales Vertriebsvolumen",
    "header__count_plural": "Offen",
    "header__count_singular": "Offen",
    "header__seleceted_count": "ausgewählt",

    "actions__select_all": "Alle auswählen",
    "actions__email": "Email",
    "actions__task": "Aufgabe",
    "actions__quote": "Angebot",
    "actions__order": "Auftrag"
}
